const MelanomaPopupToggle = async () => {
    document.getElementById("melonoma-popup").classList.toggle("show-melonoma-popup");
    const response = await fetch('https://www.biminibayoutfitters.com/pages/melanoma-research-alliance-partnership');
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const content = html.querySelector('#main');
    document.querySelector('#melonoma-popup .content.desktop').innerHTML = content.innerHTML;
    document.querySelector('#melonoma-popup .content.mobile').innerHTML = content.innerHTML;
  }

const MelanomaToggle = (e) => {
    [...[...document.getElementsByClassName("melonoma-toggle")][0].children].map(item => {
        if (item.id == e.target.id){
            item.classList.add("active");
        }else{
            item.classList.remove("active");
        }
    });

    [...[...document.getElementsByClassName("content")][0].children].map(item => {
        if (item.id == e.target.id){
            item.classList.remove("hidden");
        }else{
            item.classList.add("hidden");
        }
    });

    [...[...document.getElementsByClassName("content")][1].children].map(item => {
        if (item.id == e.target.id){
            item.classList.remove("hidden");
        }else{
            item.classList.add("hidden");
        }
    })
}
